"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../atoms");

var _NavHeader = require("./NavHeader.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NavHeader = ({
  showCloseIcon,
  onClickIcon,
  iconName,
  label,
  onClose,
  iconSize
}) => {
  return /*#__PURE__*/_react.default.createElement(_NavHeader.NavHeaderStyle, {
    iconSize: iconSize,
    "data-testid": `nav-header-${label}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "left",
    onClick: onClickIcon,
    "data-testid": `nav-header-action-${iconName}`
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: iconName,
    size: iconSize
  }), /*#__PURE__*/_react.default.createElement("label", null, label)), showCloseIcon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: "CircleClose",
    size: 40,
    fill: _atoms.theme.palette.brand.primary.white,
    onClick: onClose
  }));
};

exports.NavHeader = NavHeader;
NavHeader.defaultProps = {
  showCloseIcon: true,
  iconSize: 50
};
NavHeader.propTypes = {
  showCloseIcon: _propTypes.default.bool,
  onClickIcon: _propTypes.default.func,
  iconName: _propTypes.default.string,
  label: _propTypes.default.string,
  onClose: _propTypes.default.func,
  iconSize: _propTypes.default.number
};